import { Page } from '@roc/feature-app-core';
import { useStore } from '@roc/client-portal-shared/hooks';
import { Route } from 'react-router';
import { TitleHistoryLookup } from '../components/titleHistoryLookup';

export const getTitleHistoryLookupRoutesConfig = (basePath: string, baseUrl: string) => {
  return {
    titleHistoryLookup: {
      path: `${basePath}/title-history`,
      url: `${baseUrl}/title-history`,
      documentTitle: 'Title History Lookup',
    },
  };
};

export const getTitleHistoryLookupRoutes = (basePath: string, baseUrl: string) => {
  const config = getTitleHistoryLookupRoutesConfig(basePath, baseUrl);
  const { titleHistoryLookupStore } = useStore();
  return {
    titleHistoryLookup: (
      <Route exact path={config.titleHistoryLookup.path}>
        <Page routeDefinition={config.titleHistoryLookup}>
          <TitleHistoryLookup store={titleHistoryLookupStore} />
        </Page>
      </Route>
    ),
  };
};
